import { Skeleton } from "@/shared/ui";

export default function ContractorPayrollDetailSkeleton() {
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between pt-1 pb-4 border-b surface-base-stroke mb-5">
        <div className="flex items-center gap-3">
          <Skeleton width={280} height={32} />
          <Skeleton width={120} height={24} borderRadius={12} />
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 mb-4">
        {Array.from({ length: 4 }).map(function renderStatCardSkeleton(_, i) {
          return (
            <div key={i} className="surface-container-fill radius-3xl p-5 flex flex-col gap-3">
              <div className="flex items-center gap-2">
                <Skeleton width={32} height={32} borderRadius={6} />
                <Skeleton width={100} height={16} />
              </div>
              <Skeleton width={80} height={32} />
            </div>
          );
        })}
      </div>

      <div className="px-6 py-5 surface-base-fill radius-3xl">
        <div className="flex flex-col">
          <div className="grid grid-cols-7 gap-4 pb-3 border-b surface-base-stroke">
            {Array.from({ length: 7 }).map(function renderHeadSkeleton(_, i) {
              return <Skeleton key={i} height={20} />;
            })}
          </div>
          {Array.from({ length: 5 }).map(function renderRowSkeleton(_, rowIndex) {
            return (
              <div key={rowIndex} className="grid grid-cols-7 gap-4 py-3 border-b surface-base-stroke">
                <div className="flex items-center gap-2">
                  <Skeleton width={32} height={32} borderRadius="50%" />
                  <Skeleton width={90} height={14} />
                </div>
                {Array.from({ length: 6 }).map(function renderCellSkeleton(_, colIndex) {
                  return <Skeleton key={colIndex} height={20} />;
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
